import styled from 'styled-components';
import { shape, string } from 'prop-types';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { C_METAL } from '@bbc/psammead-styles/colours';
import { getDoublePica } from '@bbc/gel-foundations/typography';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
var HeadingIndex = /*#__PURE__*/styled.h1.attrs(function () {
  return {
    tabIndex: '-1'
  };
}).withConfig({
  displayName: "HeadingIndex",
  componentId: "sc-1155hfb-0"
})(["", ";", ";color:", ";margin:0;"], function (_ref) {
  var script = _ref.script;
  return script && getDoublePica(script);
}, function (_ref2) {
  var service = _ref2.service;
  return getSansRegular(service);
}, C_METAL);
HeadingIndex.propTypes = {
  script: shape(scriptPropType).isRequired,
  service: string.isRequired
};
export default HeadingIndex;